import { useEffect, useRef, useCallback } from 'react';

export const useMultiTimeout = () => {
  const timeoutMap = useRef<Map<string, NodeJS.Timeout>>(new Map());

  const set = useCallback((key: string, callback: () => void, delay: number) => {
    // Clear existing timeout if present
    if (timeoutMap.current.has(key)) {
      clearTimeout(timeoutMap.current.get(key));
    }

    const handle = setTimeout(() => {
      timeoutMap.current.delete(key); // Remove after execution
      callback();
    }, delay);

    timeoutMap.current.set(key, handle);
  }, []);

  const clear = useCallback((key: string) => {
    if (timeoutMap.current.has(key)) {
      clearTimeout(timeoutMap.current.get(key));
      timeoutMap.current.delete(key);
    }
  }, []);

  const clearAll = useCallback(() => {
    timeoutMap.current.forEach(clearTimeout);
    timeoutMap.current.clear();
  }, []);

  useEffect(() => {
    return () => clearAll(); // cleanup on unmount
  }, [clearAll]);

  return { set, clear, clearAll };
};
